import React, { useState, useEffect } from "react";
import { cn } from "../../utils/twMerge";
import { FaChevronDown } from "react-icons/fa";
import { chevronDownIcon } from "../../assetData/icons";

const CustomTablePagination = (props) => {
  const { table, renderKey, pageName, pagination } = props;
  const totalPage = table.getPageCount();
  const maxselector = 3;

  const totalSelectorList = Array.from(
    { length: totalPage },
    (_, index) => index,
  );

  const storedPage = pageName && Number(sessionStorage.getItem(pageName));

  const [activeSelectedPage, setActiveSelectedPage] = useState(
    storedPage ? storedPage : 1,
  );

  useEffect(() => {
    if (storedPage && storedPage !== activeSelectedPage) {
      setActiveSelectedPage(storedPage);
      setselectorIdx(calculateSelectorIdx(storedPage));
    }
  }, [storedPage, table]);

  const calculateSelectorIdx = (page) => {
    if (totalPage <= maxselector) {
      return { first: 0, last: totalPage };
    }
    if (page <= 2) {
      return { first: 0, last: maxselector };
    }
    if (page >= totalPage - 1) {
      return {
        first: totalPage - maxselector,
        last: totalPage,
      };
    }
    return {
      first: page - 2,
      last: page + 1,
    };
  };

  const [selectorIdx, setselectorIdx] = useState(
    calculateSelectorIdx(activeSelectedPage),
  );

  const activeSelectorList = totalSelectorList.slice(
    selectorIdx.first,
    selectorIdx.last,
  );

  const handleNext = () => {
    const newPage = activeSelectedPage + 1;
    setActiveSelectedPage(newPage);
    setselectorIdx(calculateSelectorIdx(newPage));
    table.nextPage();
  };

  const handlePrev = () => {
    const newPage = activeSelectedPage - 1;
    setActiveSelectedPage(newPage);
    setselectorIdx(calculateSelectorIdx(newPage));
    table.previousPage();
  };

  const handleFirstPage = () => {
    setActiveSelectedPage(1);
    setselectorIdx(calculateSelectorIdx(1));
    table.setPageIndex(0);
  };

  const handleLastPage = () => {
    const lastPageIndex = totalPage - 1;
    setActiveSelectedPage(lastPageIndex + 1);
    setselectorIdx(calculateSelectorIdx(lastPageIndex + 1));
    table.setPageIndex(lastPageIndex);
  };

  useEffect(() => {
    if (activeSelectedPage !== storedPage && pageName) {
      sessionStorage.setItem(pageName, activeSelectedPage);
    }
  }, [activeSelectedPage, pageName]);

  useEffect(() => {
    setselectorIdx(calculateSelectorIdx(activeSelectedPage));
  }, [activeSelectedPage, totalPage]);

  useEffect(() => {
    if (!pageName && pagination?.pageIndex === 0) {
      setActiveSelectedPage(1)
    }
  }, [ pageName, pagination]);

  return (
    <div className=" mx-auto items-center justify-center">
      <div className="flex w-[100%] items-center justify-center gap-[3%] py-8">
        <div className="flex items-center gap-1 text-black max-md:hidden  max-sm:hidden">
          <div>Page</div>
          <strong>{table.getState().pagination.pageIndex + 1}</strong>
          of
          <strong>{table.getPageCount()}</strong>
        </div>
        <button
          className={cn(
            "text-sm text-black max-md:hidden  max-sm:hidden",
            !table.getCanPreviousPage() && "opacity-40",
          )}
          onClick={handleFirstPage}
          disabled={!table.getCanPreviousPage()}
        >
          First Page
        </button>
        <button
          className={cn(
            "flex h-[40px] w-[45px] items-center justify-center rounded-md border-[1px] border-black text-[18px] text-black md:hidden",
            !table.getCanPreviousPage() && "opacity-40",
          )}
          onClick={handleFirstPage}
          disabled={!table.getCanPreviousPage()}
        >
          <img src={chevronDownIcon} alt="i4invest" className="rotate-90" />
          <img src={chevronDownIcon} alt="i4invest" className="rotate-90" />
        </button>

        <button
          className={cn(
            "text-sm text-black max-md:hidden  max-sm:hidden ",
            !table.getCanPreviousPage() && "opacity-40",
          )}
          onClick={handlePrev}
          disabled={!table.getCanPreviousPage()}
        >
          Prev
        </button>

        <button
          className={cn(
            "flex h-[40px] w-[45px] items-center justify-center rounded-md border-[1px] border-black text-[18px] text-black md:hidden",
            !table.getCanPreviousPage() && "opacity-40",
          )}
          onClick={handlePrev}
          disabled={!table.getCanPreviousPage()}
        >
          <img src={chevronDownIcon} alt="i4invest" className="rotate-90" />
        </button>

        <div className="flex  items-center  justify-center gap-2">
          {activeSelectedPage > 3 && <div>...</div>}

          {activeSelectorList.map((index) => (
            <div
              key={index}
              className={cn(
                "flex aspect-square w-[40px] cursor-pointer items-center justify-center rounded text-black hover:bg-neutral-200",
                activeSelectedPage === index + 1 &&
                  "bg-pri-clr-orange text-white hover:bg-[#e97a55]",
              )}
              onClick={() => {
                setActiveSelectedPage(index + 1);
                setselectorIdx(calculateSelectorIdx(index + 1));
                table.setPageIndex(index);
              }}
            >
              {index + 1}
            </div>
          ))}

          {activeSelectedPage < totalPage - 1 && totalPage > maxselector && (
            <div>...</div>
          )}
        </div>

        <button
          className={cn(
            " text-sm text-black max-md:hidden  max-sm:hidden",
            !table.getCanNextPage() && "opacity-40",
          )}
          onClick={handleNext}
          disabled={!table.getCanNextPage()}
        >
          Next
        </button>

        <button
          className={cn(
            "flex h-[40px] w-[45px] items-center justify-center rounded-md border-[1px] border-black text-[18px] text-black md:hidden",
            !table.getCanNextPage() && "opacity-40",
          )}
          onClick={handleNext}
          disabled={!table.getCanNextPage()}
        >
          <img
            src={chevronDownIcon}
            alt="i4invest"
            className="rotate-[270deg]"
          />
        </button>

        <button
          className={cn(
            "text-sm text-black max-md:hidden  max-sm:hidden",
            !table.getCanNextPage() && "opacity-40",
          )}
          onClick={handleLastPage}
          disabled={!table.getCanNextPage()}
        >
          Last Page
        </button>

        <button
          className={cn(
            "flex h-[40px] w-[45px] items-center justify-center rounded-md border-[1px] border-black text-[18px] text-black md:hidden",
            !table.getCanNextPage() && "opacity-40",
          )}
          onClick={handleLastPage}
          disabled={!table.getCanNextPage()}
        >
          <img
            src={chevronDownIcon}
            alt="i4invest"
            className="rotate-[270deg]"
          />

          <img
            src={chevronDownIcon}
            alt="i4invest"
            className="rotate-[270deg]"
          />
        </button>
      </div>
      <div className="absolute left-[50%] flex -translate-x-[50%] items-center gap-1 text-[20px] text-black md:hidden">
        <div>Page</div>
        <strong>{table.getState().pagination.pageIndex + 1}</strong>
        of
        <strong>{table.getPageCount()}</strong>
      </div>
    </div>
  );
};

export default CustomTablePagination;
